import { NgModule } from '@angular/core';
import { SharedModule } from 'cbc-shared-lib';

import { SgKdMainRoutingModule } from './sg-kd-main-routing.module';
import { SgBaseSharedModule } from '../../sg-base/sg-base-shared/sg-base-shared.module';

import { Sgkd002dComponent } from './pages/sgkd002d/pages/sgkd002d.component';
import { Sgkd002dBasicComponent } from './pages/sgkd002d/components/sgkd002d-basic/sgkd002d-basic.component';
import { Sgkd002dSelectPayInfoComponent } from './pages/sgkd002d/components/sgkd002d-select-pay-info/sgkd002d-select-pay-info.component';
import { Sgkd002dKouzaComponent } from './pages/sgkd002d/components/sgkd002d-kouza/sgkd002d-kouza.component';
import { Sgkd002dCrdComponent } from './pages/sgkd002d/components/sgkd002d-crd/sgkd002d-crd.component';
import { Sgkd002dSmsComponent } from './pages/sgkd002d/components/sgkd002d-sms/sgkd002d-sms.component';
import { Sgkd002dButtonComponent } from './pages/sgkd002d/components/sgkd002d-button/sgkd002d-button.component';

import { Sgkd004dComponent } from './pages/sgkd004d/pages/sgkd004d.component';
import { Sgkd004dSearchConditionComponent } from './pages/sgkd004d/components/sgkd004d-search-condition/sgkd004d-search-condition.component';
import { Sgkd004dSearchResultComponent } from './pages/sgkd004d/components/sgkd004d-search-result/sgkd004d-search-result.component';

import { Sgkd010dComponent } from './pages/sgkd010d/pages/sgkd010d.component';
import { Sgkd010dSearchConditionComponent } from './pages/sgkd010d/components/sgkd010d-search-condition/sgkd010d-search-condition.component';
import { Sgkd010dSearchResultComponent } from './pages/sgkd010d/components/sgkd010d-search-result/sgkd010d-search-result.component';

import { Sgkd019dComponent } from './pages/sgkd019d/pages/sgkd019d.component';
import { Sgkd019dSendtoSearchComponent } from './pages/sgkd019d/components/sgkd019d-sendto-search/sgkd019d-sendto-search.component';
import { Sgkd019dSendtoInfoComponent } from './pages/sgkd019d/components/sgkd019d-sendto-info/sgkd019d-sendto-info.component';
import { Sgkd019dHakkomotoComponent } from './pages/sgkd019d/components/sgkd019d-hakkomoto/sgkd019d-hakkomoto.component';
import { Sgkd017dDownloadConditionComponent } from './pages/sgkd017d/components/sgkd017d-download-condition/sgkd017d-download-condition.component';
import { Sgkd017dDownloadResultComponent } from './pages/sgkd017d/components/sgkd017d-download-result/sgkd017d-download-result.component';
import { Sgkd017dComponent } from './pages/sgkd017d/pages/sgkd017d.component';

@NgModule({
  declarations: [
    Sgkd002dComponent,
    Sgkd002dBasicComponent,
    Sgkd002dButtonComponent,
    Sgkd002dCrdComponent,
    Sgkd002dKouzaComponent,
    Sgkd002dSelectPayInfoComponent,
    Sgkd002dSmsComponent,
    Sgkd004dComponent,
    Sgkd004dSearchConditionComponent,
    Sgkd004dSearchResultComponent,
    Sgkd010dComponent,
    Sgkd010dSearchConditionComponent,
    Sgkd010dSearchResultComponent,
    Sgkd019dComponent,
    Sgkd019dSendtoSearchComponent,
    Sgkd019dSendtoInfoComponent,
    Sgkd019dHakkomotoComponent,
    Sgkd017dDownloadConditionComponent,
    Sgkd017dDownloadResultComponent,
    Sgkd017dComponent,
  ],
  imports: [
    SharedModule,
    SgKdMainRoutingModule,
    SgBaseSharedModule,
  ],
  exports: [
  ],
  providers: [
  ]
})
export class SgKdMainModule { }
